import React, { memo, useCallback, useMemo } from 'react'
import { useStyles } from './styles'
import { ToggleButton, ToggleButtonGroup } from '@mui/material'
import { useNavigate, useLocation, matchPath, generatePath } from 'react-router-dom'
import ROUTES from '../../../assets/routes'
import useSelectPrimaryOrUnderlyingSecurity from '../../../hooks/useSelectPrimaryOrUnderlyingSecurity'
import { exchangeToJSON } from '../../../proto/generated/common'
import { OpenInterestScreen } from '../../../assets/constants'

const OpenInterestHeader: React.FC = () => {
    const { classes } = useStyles()
    const navigate = useNavigate()
    const location = useLocation()
    const { primaryOrUnderlying } = useSelectPrimaryOrUnderlyingSecurity()

    const currentScreen = useMemo(() => {
        if (matchPath(ROUTES.oiOverview, location.pathname)) {
            return OpenInterestScreen.OI_OVERVIEW
        }
        if (matchPath(ROUTES.openInterestChange, location.pathname)) {
            return OpenInterestScreen.OI_CHANGE
        } else if (matchPath(ROUTES.openInterest, location.pathname)) {
            return OpenInterestScreen.OPEN_INTEREST
        } else if (matchPath(ROUTES.multiStrikeChart, location.pathname)) {
            return OpenInterestScreen.MULTI_STRIKE
        }
        return OpenInterestScreen.OI_CHANGE
    }, [location.pathname])

    const handleOiScreenTypeChange = useCallback((_e: any, value: OpenInterestScreen) => {
        if (!value || !primaryOrUnderlying) return
        
        let route = ROUTES.openInterestChange
        if (value === OpenInterestScreen.OI_OVERVIEW) {
            route = ROUTES.oiOverview
        } else if (value === OpenInterestScreen.OPEN_INTEREST) {
            route = ROUTES.openInterest
        } else if (value === OpenInterestScreen.MULTI_STRIKE) {
            route = ROUTES.multiStrikeChart
        }
        
        navigate(generatePath(route, {
            exchange: exchangeToJSON(primaryOrUnderlying.exchange),
            symbol: primaryOrUnderlying.code
        }))
    }, [navigate, primaryOrUnderlying])

    return (
        <div id={'multistrike-top-bar-options'} className={classes.container} style={{ padding: 0 }}>
            <div className={classes.item}>
                <ToggleButtonGroup
                    id={'oi-screen-options'}
                    className={classes.item}
                    value={currentScreen}
                    exclusive
                    size="small"
                    onChange={handleOiScreenTypeChange}
                    aria-label="text alignment"
                    sx={{
                        textWrap: 'nowrap',
                        height: '35px',
                        '.MuiButtonBase-root': {
                            borderColor: (theme) => theme.palette.background.default
                        },
                        ml: '8px !important'
                    }}
                >
                    <ToggleButton value={OpenInterestScreen.OI_OVERVIEW} aria-label="overview">
                        Overview
                    </ToggleButton>
                    <ToggleButton value={OpenInterestScreen.OI_CHANGE} aria-label="left aligned">
                        OI Change
                    </ToggleButton>
                    <ToggleButton value={OpenInterestScreen.OPEN_INTEREST} aria-label="centered">
                        Open Interest
                    </ToggleButton>
                    <ToggleButton value={OpenInterestScreen.MULTI_STRIKE} aria-label="right aligned">
                        Multistrike
                    </ToggleButton>
                </ToggleButtonGroup>
            </div>
        </div>
    )
}

export default memo(OpenInterestHeader)